import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=3dc77f0a"
import script from "./LinkedIn.vue?vue&type=script&lang=js"
export * from "./LinkedIn.vue?vue&type=script&lang=js"
import style0 from "./LinkedIn.vue?vue&type=style&index=0&id=3dc77f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports